import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";

import { ValidationService } from "app/common/validation/validation.service";
import { AbstractWizardStepComponent } from "app/administrative/wizard-dialog/abstract-wizard-step.component";
import { GatewayEditWizardService, PrivateGatewayEdit } from "../gateway-edit-wizard.service";
import { GatewayEditIpPortsComponent } from "../gateway-edit-ip-ports/gateway-edit-ip-ports.component";
import { GatewayEditDnsComponent } from "../gateway-edit-dns/gateway-edit-dns.component";

type PrivateGatewayStep = "dns" | "ip-port";

@Component({
	selector: "sdp-gateway-edit-name",
	templateUrl: "./gateway-edit-name.component.html"
})
export class GatewayEditNameComponent extends AbstractWizardStepComponent<PrivateGatewayEdit> implements OnInit {
	public form!: FormGroup;
	public next: AbstractWizardStepComponent.ConstructorFunction<PrivateGatewayEdit> | undefined;

	constructor(
		private formBuilder: FormBuilder,
		private validationService: ValidationService,
		private service: GatewayEditWizardService
	) {
		super();
	}

	public ngOnInit() {
		this.form = this.formBuilder.group({
			label: [
				this.data.editGateway.label,
				Validators.compose([
					Validators.required,
					this.validationService.simpleStringWithSpaces
				])
			],
		});
	}

	public get title() {
		return "gateway.edit.title";
	}

	public get description() {
		return "gateway.edit.name.description";
	}

	public get nextStep() {
		return this.next;
	}

	public async gotoStep(step: PrivateGatewayStep) {
		switch (step) {
			case "dns":
				this.next = GatewayEditDnsComponent;
				break;
			case "ip-port":
				this.next = GatewayEditIpPortsComponent;
				break;
		}
		await this.wizard.goNext();
	}

	public get previousStep(): AbstractWizardStepComponent.ConstructorFunction<PrivateGatewayEdit> | undefined {
		return undefined;
	}

	public get isFormValid() {
		return !this.form || this.form.valid;
	}

	public performPrevious() {
		this.service.processName(this.form.getRawValue());
	}

	public async performNext() {
		this.service.processName(this.form.getRawValue());
		if (!this.next) {
			await this.service.processGateway();
		}
	}

	public get showProgressBar() {
		return false;
	}
}
